/* eslint-disable no-comments/disallowComments */
import { RecordStatus } from '@fleet-beat/api';
import { OrderBy } from '@fleet-beat/core';

export interface GetManyV2Dto {
  boundingBox?: string;
  orderBy?: string;
  filterLocallyBy?: string;
  order?: OrderBy;
  limit?: number;
  offset?: number;
  address?: number;
  search?: string;
  include?: string;
  statuses?: string;
  expirationDate?: string;
  companyIds?: string;
  companyId?: string;
  forCompanyId?: string;
  roles?: string;
  tenantIds?: string;
  createdAt?: string;
  logsDateRange?: string;
  dateRange?: string;
  recordStatuses?: RecordStatus;
  sort?: string;
  total?: number;
  isActive?: boolean;
  isLocked?: boolean;
  itemIds?: string;
  original?: boolean;
  driverId?: string;
  driverIds?: string;
  truckIds?: string;
  product?: string;
}

// потрібно зробити рефакторинг, всі унікальні поля вивести в окремі інтерфейси там де воно потрібно !!!!!!!!!!!!!!!!
